<template>
  <span>
    Booking
    <router-link
      tag="a"
      :to="`/bookings/overview/:date?${eventLog.bookingId}`"
      >#{{ eventLog.bookingId }}
    </router-link>
    moved
  </span>
</template>
<script>
export default {
  name: 'recentActivityTableDescriptionBookingRescheduled',
  props: {
    eventLog: {
      type: Object,
      default: () => {}
    }
  }
}
</script>
